import * as Scrivito from "scrivito";
import {
  defaultFormInputEditingAttributes,
  defaultFormInputEditingProperties,
  defaultFormInputInitialContent,
} from "../../_defaultFormEditingConfig";

Scrivito.provideEditingConfig("InputWidget", {
  title: "Input",
  attributes: {
    ...defaultFormInputEditingAttributes,
    propertyName: {
      title: "Input Type",
      description:
        "Select if this field is an email, or a postal code for input validation purposes",
      values: [
        { value: "email", title: "Email" },
        { value: "text", title: "Text" },
      ],
    },
    placeholder: {
      title: "Placeholder",
    },
  },
  properties: [
    ...defaultFormInputEditingProperties,
    "placeholder",
    "propertyName",
  ],
  initialContent: {
    ...defaultFormInputInitialContent,
    propertyName: "text",
  },
  validations: [
    [
      "csvColumnName",
      (csvColumnName) => {
        if (!csvColumnName) {
          return "CSV column name is required";
        }
        return null;
      },
    ],
  ],
});
